import React, { useState, useEffect } from 'react';
import { useStore, useDispatch } from 'react-redux';
import { Layout } from 'antd';
import PropTypes from 'prop-types';

import mainRoutes from '@routes/mainRoutes';
import Header from '@common/containers/Header';
import SiderMenu from '@common/containers/SiderMenu';
import EssentialContent from '@common/containers/EssentialContent';
import BrandImage from '@common/components/ui/BrandImage';

import userActions from '@state/user/actions';

import styles from './MainLayout.module.less';

const { Header: HeaderWrapper, Sider } = Layout;
// eslint-disable-next-line
export let siderCollapsed = true;

function MainLayout(props) {

  const dispatch = useDispatch();
  const store = useStore();
  const { isFirstTime } = store.getState().user;

  const {
    // eslint-disable-next-line
    children, headerComponent, footerComponent, applyPadding, applyWidthLimit,
  } = props;
  const [isSiderCollapsed, setSiderCollapsed] = useState(isFirstTime ? false : siderCollapsed);

  useEffect(() => {

    siderCollapsed = isSiderCollapsed;
    if (isFirstTime) dispatch(userActions.setFirstTime(false));
    // eslint-disable-next-line
  }, [isSiderCollapsed]);

  return (
    <Layout className={styles.container}>
      <Sider className={styles.sider} collapsed={isSiderCollapsed} trigger={null} width={270}>
        <div className={`${styles.sider_logo} primary_bg`}>
          <BrandImage
            show={isSiderCollapsed ? 'icon' : 'logo'}
            style={{ padding: isSiderCollapsed ? 14 : 12 }}
          />
        </div>
        <div className={styles.sider_menu}>
          <SiderMenu routes={mainRoutes} isCollapsed={isSiderCollapsed} />
        </div>
      </Sider>
      <Layout className={styles.content_wrapper}>
        <HeaderWrapper className={styles.header_wrapper}>
          <Header
            isShowMenu={isSiderCollapsed}
            handlerShowMenu={() => setSiderCollapsed(!isSiderCollapsed)}
          />
        </HeaderWrapper>
        <EssentialContent
          headerComponent={headerComponent}
          footerComponent={footerComponent}
          applyPadding={applyPadding}
          applyWidthLimit={applyWidthLimit}
        >
          {children}
        </EssentialContent>
      </Layout>
    </Layout>
  );

}

MainLayout.propTypes = {
  headerComponent: PropTypes.node,
  footerComponent: PropTypes.node,
  applyPadding: PropTypes.bool,
  applyWidthLimit: PropTypes.bool,
};

MainLayout.defaultProps = {
  headerComponent: null,
  footerComponent: null,
  applyPadding: true,
  applyWidthLimit: false,
};

export default MainLayout;
